import { Image } from '@gousto-internal/citrus-react'
import React from 'react'
import { RecipeImageLayout } from './CuratedBoxImageLayout.styled'

export type RecipeImageGridProps = {
  numPortions: number
  curatedBoxImgURLS: string[]
}

type AvailableRecipeCount = 5 | 4 | 3

const RecipeImageMap = ({ curatedBoxImgURLS }: RecipeImageGridProps) => {
  return (
    <>
      {curatedBoxImgURLS.map((item: string, index: number) => (
        <Image fit="cover" key={`${item}-${index}`} alt="" src={item} />
      ))}
    </>
  )
}

const RecipeImageGrid = ({
  numPortions,
  curatedBoxImgURLS,
  layout,
}: RecipeImageGridProps & { layout: AvailableRecipeCount }) => (
  <RecipeImageLayout layout={layout}>
    <RecipeImageMap numPortions={numPortions} curatedBoxImgURLS={curatedBoxImgURLS} />
  </RecipeImageLayout>
)

export const CuratedBoxImageLayout = ({ numPortions, curatedBoxImgURLS }: RecipeImageGridProps) => {
  const recipesToPortionSize: { [key: number]: AvailableRecipeCount } = {
    1: 5,
    2: 5,
    3: 5,
    4: 4,
    5: 3,
  }

  const layout: AvailableRecipeCount = recipesToPortionSize[numPortions]

  return (
    <RecipeImageGrid
      numPortions={numPortions}
      curatedBoxImgURLS={curatedBoxImgURLS}
      layout={layout}
    />
  )
}
